import * as THREE from "three";
import { DoubleSide } from "three";
export class InputItem {
    private guideLineMaterial = new THREE.LineBasicMaterial({ color: 0xCCCCCC, transparent: true });
    private guideLineGeometry = new THREE.BufferGeometry();
    public line = new THREE.Line(this.guideLineGeometry, this.guideLineMaterial);
    constructor(color: THREE.Color, private isDebug: boolean) {
        this.guideLineMaterial.color = color;
    }
    public x = 0;
    public y = 0;
    public update(x: number, y: number): void {
        this.x = x;
        this.y = y;

        if (this.isDebug) {
            this.line.visible = true;
            const points = [];
            points.push(new THREE.Vector3(x, -1000, 0));
            points.push(new THREE.Vector3(x, 1000, 0));
            points.push(new THREE.Vector3(-1000, y, 0));
            points.push(new THREE.Vector3(1000, y, 0));
            this.guideLineGeometry.setFromPoints(points);
            this.guideLineGeometry.attributes.position.needsUpdate = true;
        } else {
            this.line.visible = false;
        }
    }
}
interface OnDestroy { (touch: TouchItem): void }
export class TouchItem {
    private inputs = new Map<number, InputItem>();
    private geometry = new THREE.RingGeometry(this.radius - 0.2, this.radius, 32);
    private material = new THREE.MeshBasicMaterial({ color: 0xffff00, transparent: true, side: DoubleSide });
    private geometryBack = new THREE.RingGeometry(this.radius - 0.2, this.radius, 32);
    private materialBack = new THREE.MeshBasicMaterial({ color: 0xCCCCCC, transparent: true, side: DoubleSide });
    private timerTextIndex = 0;
    private timerTextCount = 0;
    public circle = new THREE.Mesh(this.geometry, this.material);
    public circleBack = new THREE.Mesh(this.geometryBack, this.materialBack);
    public onDestroy!: OnDestroy;
    public isDebug: boolean = false;

    constructor(x: number, y: number, private radius: number, private timeout: number) {
        this.circle.position.x = x;
        this.circle.position.y = y;
    }
    public update(deltaTime: number): void {
        if (this.inputs.size == 0) return;
        let tx = 0;
        let ty = 0;

        for (const item of this.inputs.values()) {
            tx += item.x;
            ty += item.y;
        }

        this.circle.position.x = tx / this.inputs.size;
        this.circle.position.y = ty / this.inputs.size;
        this.circleBack.position.x = this.circle.position.x;
        this.circleBack.position.y = this.circle.position.y;
    }

    public addInput(id: number, input: InputItem) {
        //console.log("addInput:" + id, input);
        this.circle.geometry.dispose();
        this.circle.geometry = new THREE.RingGeometry(this.radius - 0.2, this.radius, 30, 1, 1.55, 6.3);
        this.inputs.set(id, input);
        if (this.timerTextIndex) {
            clearInterval(this.timerTextIndex);
            this.timerTextIndex = 0;
        }
    }

    public removeInput(id: number, force: boolean = false) {
        //console.log("removeInput:" + id);
        if (this.inputs.has(id)) {
            this.inputs.delete(id);
            clearInterval(this.timerTextIndex);
            if (force) {
                this.onDestroy(this);
            } else if (this.inputs.size == 0) { //debug

                this.timerTextCount = this.timeout;
                this.timerTextIndex = setInterval(() => {
                    this.timerTextCount -= 10;
                    this.circle.geometry.dispose();
                    this.circle.geometry = new THREE.RingGeometry(this.radius - 0.2, this.radius, 30, 1, 1.55, 6.3 * (this.timerTextCount / this.timeout));
                    if (this.timerTextCount <= 0) {
                        clearInterval(this.timerTextIndex);
                        this.timerTextIndex = 0;
                        this.onDestroy(this);
                    }
                }, 10);
            }
        }
    }
    public hasInput(id: number): boolean {
        return this.inputs.has(id);
    }
    public IsIn(x: number, y: number): boolean {
        if (this.circle.position.x + this.radius >= x && this.circle.position.x - this.radius <= x && this.circle.position.y + this.radius >= y && this.circle.position.y - this.radius <= y) {
            return true;
        }
        return false;
    }
}